import React from "react";

const FormSection = ({ title, description, columns, children, className = "" }) => (
  <section className={`fld-section ${className}`}>
    {(title || description) && (
      <div className="fld-section__head">
        {title && <h3 className="fld-section__title">{title}</h3>}
        {description && <p className="fld-section__desc">{description}</p>}
      </div>
    )}
    <div
      className="fld-grid"
      style={
        columns
          ? { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }
          : undefined
      }
    >
      {children}
    </div>
  </section>
);

export default FormSection;
